import React from 'react'
import Helmet from 'react-helmet'

const RecipeJsonLd = ({ recipeData }) => {
    const recipeStructuredData = {
        "@context": "http://schema.org",
        "@type": "Recipe",
        "author": {
            "@type":"Person",
            "name":"Jayanthy Kumaran"
        },
        "name": recipeData.title,
        "description": recipeData.description.replace(/\n/g, ' '),
        "image": {
            "@type": "ImageObject",
            "url": "https://tastyappetite.net" + recipeData.featureImage.childImageSharp.fluid.src
        },
        "recipeIngredient": recipeData.ingredients.split('\n').map((i) => i.replace(/\s\s+/g, ' ')),
        "recipeInstructions": recipeData.instructions.split('\n').filter((i) => (i.trim().length > 0)).map((instruction) => {
            return ({
                "@type":"HowToStep",
                "text": instruction
             })
        }),
        "publisher":{
            "@type":"Organization",
            "name":"Tasty Appetite",
            // "logo":{
            //    "@type":"ImageObject",
            //    "url":"https://tasty.co/favicon.ico"
            // }
         },
         "datePublished": recipeData['originalCreatedAt'] || recipeData['created_at'],
    }

    if(recipeData['yieldInServings']){ recipeStructuredData['recipeYield'] = recipeData['yieldInServings'] + ' servings'}
    if(recipeData['cookingTimeMinutes']){ recipeStructuredData['cookTime'] = 'PT' + recipeData['cookingTimeMinutes'] + 'M'}
    if(recipeData['recipe_category']){ recipeStructuredData['recipeCategory'] = recipeData.recipe_category.name}
    if(recipeData['recipe_cuisine']){ recipeStructuredData['recipeCuisine'] = recipeData.recipe_cuisine.name}
    if(recipeData['keywords']){ recipeStructuredData['keywords'] = recipeData.keywords.map(k => k.name)}
    if(recipeData['youtubeURL']){ recipeStructuredData['video'] = {
        "@type": "VideoObject", 
        "name": recipeData.title,
        "embedUrl": recipeData['youtubeURL']
    }}
    if(recipeData['calorieCount']){
        recipeStructuredData['nutrition'] = {
            "@type":"NutritionInformation",
            "calories": recipeData['calorieCount'] + " calories",
        }
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(recipeStructuredData)}</script>
        </Helmet>
    )
}

export default RecipeJsonLd